import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { SelectFacetTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/selectFacet.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: SelectFacetTrackingInfo) => {
    const event: AnalyticsEvent<SelectFacetTrackingInfo> = {
        event: EventType.SelectFacet,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackFacet = (
    facetName: string,
    facetValue: string,
    index: string
) => {
    const trackingInfo: SelectFacetTrackingInfo = {
        filter: `${facetName}:${encodeURIComponent(facetValue)}`,
        index: index
    };

    track(trackingInfo);
};
